import { Solicitacao } from '@/types/solicitacao';
import { formatBrazilTime } from '@/utils/timezone';
import { getSLAStatus } from '@/utils/slaStatus';

export const exportRequisicoesToCSV = (requisicoes: Solicitacao[], filename?: string) => {
  if (!requisicoes || requisicoes.length === 0) {
    return;
  }

  // Definir cabeçalhos do CSV
  const headers = [
    'Número',
    'Título',
    'Status',
    'Urgência',
    'Prioridade',
    'Solicitante',
    'Cliente',
    'Grupo Responsável',
    'Atendente',
    'Data Criação',
    'Data Limite Resposta',
    'Data Limite Resolução',
    'Data de Resolução',
    'SLA Status',
    'Categoria',
    'Canal Origem',
    'Notas Internas'
  ];

  // Converter dados para formato CSV
  const csvData = requisicoes.map(req => {
    const slaStatus = getSLAStatus(req);
    
    return [
      req.numero || '',
      `"${(req.titulo || '').replace(/"/g, '""')}"`, // Escapar aspas duplas
      req.status || '',
      req.urgencia || '',
      req.prioridade || '',
      req.solicitante?.name || '',
      req.cliente?.name || '',
      req.grupo_responsavel?.name || '',
      req.atendente?.name || '',
      req.criado_em ? formatBrazilTime(req.criado_em, 'dd/MM/yyyy HH:mm') : '',
      req.data_limite_resposta ? formatBrazilTime(req.data_limite_resposta, 'dd/MM/yyyy HH:mm') : '',
      req.data_limite_resolucao ? formatBrazilTime(req.data_limite_resolucao, 'dd/MM/yyyy HH:mm') : '',
      req.data_resolucao ? formatBrazilTime(req.data_resolucao, 'dd/MM/yyyy HH:mm') : '',
      slaStatus.label || '',
      req.categoria?.nome || '',
      req.canal_origem || '',
      `"${(req.notas_internas || '').replace(/"/g, '""')}"` // Escapar aspas duplas
    ];
  });

  // Combinar cabeçalhos e dados
  const csvContent = [
    headers.join(','),
    ...csvData.map(row => row.join(','))
  ].join('\n');

  // Criar e baixar o arquivo
  const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', filename || `requisicoes_${new Date().toISOString().split('T')[0]}.csv`);
    link.style.visibility = 'hidden';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }
};

export const exportFilteredRequisicoesToCSV = (
  requisicoes: Solicitacao[],
  filteredCount: number,
  filename?: string
) => {
  const baseFilename = filename || `requisicoes_filtradas_${new Date().toISOString().split('T')[0]}`;
  const finalFilename = `${baseFilename}_${filteredCount}_registros.csv`;
  
  exportRequisicoesToCSV(requisicoes, finalFilename);
};
